import { ReduceStore } from 'flux/utils';
import Dispatcher from './../Dispatcher';
import ActionTypes from './ActionTypes';
import CollectionsManager from './CollectionsManager';

class CollectionsStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return [];
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.COLLECTIONS_STORE_FETCH:
        CollectionsManager.fetch();
        return state;

      case ActionTypes.COLLECTIONS_STORE_FETCH_COMPLETE:
        return action.data;

      default:
        return state;
    }
  }
}

export default new CollectionsStore();
